import { useEffect } from "react";

// 轻量 SEO：每个页面设置独立 document.title
export default function useSeo(title: string, desc?: string) {
  useEffect(() => {
    document.title = title;
    if (desc) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", desc);
    }
  }, [title, desc]);
}